export default __webpack_public_path__ + "static/media/bgCloud.a82a0a96.png";